/**
 * Language strings that will be properly localized and pluralized eventually
 */

import Group from 'entities/Group';
// @ts-ignore
import { EVERYONE } from 'utils/roleHelpers';

export function groupSizeForRole(group: Group, role: string = EVERYONE): number {
  if (role === EVERYONE) {
    return group.getMembershipsCount();
  } else {
    const roleObj = group.getRoles().find(r => r.role === role);
    if (roleObj && roleObj.count) {
      return roleObj.count;
    }
  }

  console.warn({ group, role });
  console.error('[recovered] groupSizeForRole could not calculate');
  return 0;
}

export function membershipDescriptionFor(group: Group, role: string = EVERYONE) {
  const size: number = groupSizeForRole(group, role);

  if (size < 1) {
    return '';
  }

  let membersDescription = 'participant';

  if (group.isStaffClass()) {
    membersDescription = 'member';
  }
  if (role !== EVERYONE) {
    membersDescription = role;
  }
  if (size !== 1) {
    membersDescription += 's';
  }
  return `${size} ${membersDescription}`;
}

export function memberTypeFor(group: Group) {
  if (group.isStaffClass()) {
    return 'members';
  } else {
    return 'participants';
  }
}
